<div>
  <h4 class="h3-alt"> {{'AGREEMENT_SIGN_CHOOSE_EXTRA' | translate}}</h4>
  <div>{{'AGREEMENT_SIGN_CHOOSE_EXTRA_DESCRIPTION' | translate: {price: cvInsuranceDeductibleEliminationPrice} }}</div>
</div>
<div class="mt-20" data-cy="choose_extra">
  <button-radio-group [formControl]="chooseExtra" [textBeforeCircle]="false"
                      [optionsObj]="carOptions"></button-radio-group>
</div>
